/**
 * Mega menu — desktop aria-expanded + mobile panel toggle coordination.
 */

const DESKTOP_NAV_MQ = '(width >= 64rem)';
const isDesktopNav = () => window.matchMedia(DESKTOP_NAV_MQ).matches;
const CLOSE_DELAY_MS = 250;

class MegaMenu {
  constructor() {
    this.items = document.querySelectorAll('.nav-menu > li.is-mega-menu');
    this.closeTimer = null;

    if (!this.items.length) {
      return;
    }

    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const trigger = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > .mega-menu');

      if (!trigger || !panel) {
        return;
      }

      item.addEventListener('mouseenter', () => this.open(item, trigger, panel));
      item.addEventListener('mouseleave', () => this.scheduleClose(item, trigger, panel));
      item.addEventListener('focusin', () => this.open(item, trigger, panel));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) {
          this.scheduleClose(item, trigger, panel);
        }
      });
    });
  }

  open(item, trigger, panel) {
    if (!isDesktopNav()) {
      return;
    }

    clearTimeout(this.closeTimer);
    item.classList.add('is-mega-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    panel.removeAttribute('hidden');
  }

  scheduleClose(item, trigger, panel) {
    if (!isDesktopNav()) {
      return;
    }

    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.close(item, trigger, panel);
    }, CLOSE_DELAY_MS);
  }

  close(item, trigger, panel) {
    item.classList.remove('is-mega-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    panel.setAttribute('hidden', '');
  }

  static toggleMobile(item) {
    const trigger = item.querySelector(':scope > a');
    const panel = item.querySelector(':scope > .mega-menu');

    if (!trigger || !panel) {
      return;
    }

    const isOpen = item.classList.contains('is-mega-open');

    document.querySelectorAll('.nav-menu > .menu-item-has-children').forEach((other) => {
      if (!other.classList.contains('is-mega-menu')) {
        other.classList.remove('is-open');
        const otherSub = other.querySelector(':scope > .sub-menu');
        if (otherSub) {
          otherSub.classList.remove('is-open');
        }
      }
    });

    document.querySelectorAll('.nav-menu > li.is-mega-menu').forEach((other) => {
      if (other === item) {
        return;
      }
      const otherTrigger = other.querySelector(':scope > a');
      const otherPanel = other.querySelector(':scope > .mega-menu');
      if (otherTrigger && otherPanel) {
        other.classList.remove('is-mega-open');
        otherTrigger.setAttribute('aria-expanded', 'false');
        otherPanel.classList.remove('is-open');
        otherPanel.setAttribute('hidden', '');
      }
    });

    if (isOpen) {
      item.classList.remove('is-mega-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      panel.setAttribute('hidden', '');
    } else {
      item.classList.add('is-mega-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.removeAttribute('hidden');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.PvtlMegaMenu = new MegaMenu();
  });
} else {
  window.PvtlMegaMenu = new MegaMenu();
}

export default MegaMenu;
